export default __webpack_public_path__ + "static/media/photo--sm--food-1.6af8fd49.jpg";